import React from 'react';
import type { TherapyGeneration } from '@lmt/signal-viewer-processor';
import { CrossIcon } from './icons/CrossIcon';
import { useFileSession } from '../contexts/FileSessionContext';
import './FileInfo.css';

const DEVICE_GENERATION_LABELS: Record<TherapyGeneration, string> = {
  p28: 'P2.8',
  p3: 'P3',
  p32: 'P3.2',
  p5: 'P5',
};

export const FileInfo: React.FC = () => {
  const { currentFileNames, headerGeneration, isUploadMode, onCancelUpload } =
    useFileSession();

  const fileTitle = currentFileNames?.length
    ? currentFileNames.join(', ')
    : null;

  return (
    <div className='file-info__format'>
      <span className='file-info__loaded-title'>
        {fileTitle ? (
          <>
            {headerGeneration && (
              <>
                <span className='file-info__info-label'>
                  <span>Device Generation:</span>
                  <span className='file-info__info-value'>
                    {DEVICE_GENERATION_LABELS[headerGeneration]}
                  </span>
                </span>
                <div className='file-info__loaded-title-divider' />
              </>
            )}
            <span className='file-info__info-label'>
              <span>File:</span>
              <span className='file-info__info-value'>{fileTitle}</span>
            </span>
          </>
        ) : (
          <span className='file-info__info-label'>
            No file loaded. Pick a demo file or add your own
          </span>
        )}
      </span>
      {isUploadMode && (
        <button
          className='file-info__cancel-upload'
          onClick={onCancelUpload}
          aria-label='Cancel upload'
          title='Cancel upload'
        >
          <CrossIcon size={20} />
        </button>
      )}
    </div>
  );
};
